import { map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { Permission, isAllowed } from "../../RAWMap.Models/Security.js";
import { view as view_1 } from "./ReportPrompt/ReportPromptView.js";
import { wrapOutboundMsg, wrapLocalMsg } from "../../Common/InboundOutbound.js";
import { ChildMsg_ofMsg } from "../../Common/Terminate.js";
import { childAbsentStrategy } from "./CustomStentReportState.js";
import { OutboundMsg, ModeModule_$007CDisableButtons$007CEnableButtons$007C, ModeModule_$007CSpinner$007CNoSpinner$007C, LocalMsg } from "./CustomStentReportTypes.js";
import { Helpers_nothing } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { ofArray, singleton, empty } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Button_visibilityControlled, ComponentVisibility } from "../../Common/Controls.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { screenshotModal, screenshotTable } from "../../Visualization/Screenshot/ScreenshotView.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { TableOption, table } from "../../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { sortBy, map as map_1 } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { Option, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { PromptType } from "./ReportPrompt/ReportPromptTypes.js";
import { Common_GenericOption, Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { op_UnaryNegation_Int32 } from "../../fable_modules/fable-library-js.4.19.3/Int32.js";
import { comparePrimitives } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { Option as Option_1, container } from "../../fable_modules/Fulma.3.0.0/Layouts/Container.fs.js";
import { h6, h3 } from "../../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { Option as Option_2, columns } from "../../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { Option as Option_3, column } from "../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { box$0027 } from "../../fable_modules/Fulma.3.0.0/Elements/Box.fs.js";

export function canUserViewCustomReport(maybeCurrentUser) {
    return defaultArg(map((user) => isAllowed(new Permission(20, []))(user.roles), maybeCurrentUser), false);
}

export function canUserEditCustomReportData(maybeCurrentUser) {
    return defaultArg(map((user) => isAllowed(new Permission(21, []))(user.roles), maybeCurrentUser), false);
}

export function canUserCreateCustomReport(maybeCurrentUser) {
    return defaultArg(map((user) => isAllowed(new Permission(22, []))(user.roles), maybeCurrentUser), false);
}

export function canUserDeleteCustomReport(maybeCurrentUser) {
    return defaultArg(map((user) => isAllowed(new Permission(23, []))(user.roles), maybeCurrentUser), false);
}

export function promptView(promptModel, _model, dispatch) {
    return view_1(promptModel, (arg_2) => {
        dispatch(wrapLocalMsg(new LocalMsg(4, [ChildMsg_ofMsg(childAbsentStrategy, arg_2)])));
    });
}

export function view(customReportModels, model, maybeCurrentUser, dispatch) {
    let children_10, children_8, children_20;
    const dispatchScreenshotLocal = (arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(3, [arg_1])));
    };
    let reportPrompt;
    const matchValue = model.PromptComponent.child;
    switch (matchValue.tag) {
        case 2:
        case 1: {
            reportPrompt = Helpers_nothing;
            break;
        }
        default:
            reportPrompt = promptView(matchValue.fields[0], model, dispatch);
    }
    const loadingProps = (ModeModule_$007CSpinner$007CNoSpinner$007C(model.Mode).tag === 1) ? empty() : singleton(new HTMLAttr(64, ["spinner is-loading"]));
    const buttonVisibility = (userHasPermission) => {
        if (userHasPermission) {
            const activePatternResult_1 = ModeModule_$007CDisableButtons$007CEnableButtons$007C(model.Mode);
            if (activePatternResult_1.tag === 1) {
                return new ComponentVisibility(0, []);
            }
            else {
                return new ComponentVisibility(2, [activePatternResult_1.fields[0]]);
            }
        }
        else {
            return new ComponentVisibility(1, []);
        }
    };
    let tblScreenshots;
    const props = toList(delay(() => append(singleton_1(new HTMLAttr(64, ["table-container"])), delay(() => loadingProps))));
    const children = [screenshotTable(model.ScreenshotModel, dispatchScreenshotLocal)];
    tblScreenshots = react.createElement("div", keyValueList(props, 1), ...children);
    let tblReports;
    const props_22 = toList(delay(() => append(singleton_1(new HTMLAttr(64, ["table-container"])), delay(() => loadingProps))));
    const children_22 = [table(ofArray([new TableOption(1, []), new TableOption(4, []), new TableOption(2, [])]), ofArray([(children_10 = [(children_8 = [react.createElement("th", {}, "Number"), react.createElement("th", {}, "Date Created"), react.createElement("th", {})], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_20 = ofArray(map_1((report) => {
        let children_16;
        const children_18 = [react.createElement("td", {}, `${report.reportNumber}`), react.createElement("td", {}, `${report.reportDate}`), (children_16 = [button(ofArray([new Option(18, [(_arg) => {
            dispatch(wrapLocalMsg(new LocalMsg(6, [new PromptType(1, [report.reportPath])])));
        }]), new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new HTMLAttr(159, ["button"]))])]), singleton("Download"))], react.createElement("td", {}, ...children_16))];
        return react.createElement("tr", {}, ...children_18);
    }, sortBy((r) => op_UnaryNegation_Int32(r.reportNumber), customReportModels, {
        Compare: comparePrimitives,
    }))), react.createElement("tbody", {}, ...children_20))]))];
    tblReports = react.createElement("div", keyValueList(props_22, 1), ...children_22);
    const btnGenerateReport = Button_visibilityControlled(undefined, buttonVisibility(canUserCreateCustomReport(maybeCurrentUser)), ofArray([new Option(18, [(_arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(6, [new PromptType(0, [])])));
    }]), new Option(0, [new Color_IColor(6, [])]), new Option(2, []), new Option(17, [singleton(new HTMLAttr(159, ["button"]))])]), singleton("Generate New Report"));
    const btnCancel = Button_visibilityControlled(undefined, buttonVisibility(true), ofArray([new Option(0, [new Color_IColor(8, [])]), new Option(2, []), new Option(17, [ofArray([new DOMAttr(40, [(_arg_2) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [])));
    }]), new HTMLAttr(159, ["button"])])])]), singleton("Cancel"));
    const flexColumnFill = singleton(["style", {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "0",
    }]);
    const flexFill = singleton(["style", {
        flex: "1 1 auto",
        minHeight: "0",
    }]);
    const scrollFill = singleton(["style", {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "scroll",
    }]);
    const children_28 = [container(ofArray([new Option_1(0, []), new Option_1(3, [flexColumnFill])]), ofArray([h3(empty())(singleton("Stent Plan Report")), columns(ofArray([new Option_2(1, []), new Option_2(9, [flexFill])]), ofArray([column(singleton(new Option_3(3, [flexColumnFill])), singleton(box$0027(singleton(new Common_GenericOption(1, [flexColumnFill])), ofArray([h6(empty())(singleton("Previously Generated Reports")), react.createElement("div", keyValueList(scrollFill, 1), tblReports)])))), column(singleton(new Option_3(3, [flexColumnFill])), singleton(box$0027(singleton(new Common_GenericOption(1, [flexColumnFill])), ofArray([h6(empty())(singleton("Screenshots")), react.createElement("div", keyValueList(scrollFill, 1), tblScreenshots)]))))])), box$0027(empty(), singleton(columns(singleton(new Option_2(1, [])), ofArray([column(empty(), singleton(btnGenerateReport)), column(empty(), singleton(btnCancel))]))))])), screenshotModal(model.ScreenshotModel, dispatchScreenshotLocal, !canUserEditCustomReportData(maybeCurrentUser)), reportPrompt];
    return react.createElement("div", {
        className: "visualization-dynamic-height",
    }, ...children_28);
}

